import { useLifeChoicePageContext } from "context/hooks/useLifeChoicePageContext";
import { t } from "i18next";
import { twMerge } from "tailwind-merge";

export default function ApplyButton({
  text,
  className = "",
  onClick,
  disabled,
}) {
  const { tabHandler } = useLifeChoicePageContext();

  return (
    <button
      className={twMerge(
        "bg-theme-yellow py-3 w-full text-white font-semibold text-lg rounded-2xl",
        className
      )}
      onClick={() => (onClick ? onClick() : tabHandler("apply"))}
      disabled={disabled}
    >
      {text ? text : t("applyNowButton")}
    </button>
  );
}
